import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { commissionsService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

const useUploadRevenueSourceFileMutation = () => {
	const dispatch = useDispatch();

	return useMutation(
		file => commissionsService.uploadRevenueSourceFile(file),
		{
			onMutate() {
				dispatch(uiActions.showSpinnerOverlay());
			},
			onError: (error: ErrorResponse) => {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
			onSettled() {
				dispatch(uiActions.hideSpinnerOverlay());
			},
		},
	);
};

export default useUploadRevenueSourceFileMutation;
